// api/reportsAPI.js
import axiosInstance from './axiosConfig';

const reportsAPI = {
  /**
   * Generate Profit and Loss report
   * @param {object} params - { startDate, endDate, storeId }
   * @returns {Promise} P&L report data
   */
  getProfitLoss: async (params) => {
    try {
      const response = await axiosInstance.get('/reports/profit-loss', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to generate P&L report';
    }
  },
  // New Dashboard functions
  getDashboardData: async (timeRange = 'today') => {
      const response = await axiosInstance.get(`/dashboard?range=${timeRange}`);
      return response;
  },

  getDashboardOverview: async () => {
      const response = await axiosInstance.get('/dashboard/overview');
      return response;
  },

  getSalesTrend: async (period = 'week') => {
      const response = await axiosInstance.get(`/dashboard/sales-trend?period=${period}`);
      return response;
  },

  getTopProducts: async (limit = 5) => {
      const response = await axiosInstance.get(`/dashboard/top-products?limit=${limit}`);
      return response;
  },

  getSalesTrend: async (filters = {}) => {
    const response = await axiosInstance.get('/dashboard/sales-trend', { 
        params: filters 
    });
    return response;
  },
  // Purchase Order Report
  getPurchaseOrderReport: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/reports/purchase-orders', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch purchase order report';
    }
  },

  // Purchase Return Report
  getPurchaseReturnReport: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/reports/purchase-returns', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch purchase return report';
    }
  },

  reportsChat: async ({ accountingClientId, message, timezone = 'Asia/Manila' }) => {
    try {
      const response = await axiosInstance.post('/reports/chat', {
        accountingClientId,
        message,
        timezone
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch reports chat response';
    }
  }
};

export default reportsAPI;